<template>
  <div>
    <router-link :to="{name:'WeekABC'}" class="gc-header-top">个人ABC</router-link>
    <div class="search-wrap">
      <!-- <div class="left" @click="showPicker=true">
          {{startDate?startDate:'请选择时间'}}
      </div> -->
      <div class="left" @click="showStatus=true">
        <span v-if="status==0">全部</span>
        <span v-if="status==1">可评</span>
        <span v-if="status==2">已评</span>
      </div>
      <div class="right">
        <van-search v-model="keywords" placeholder="请输入搜索关键词"/>
      </div>
    </div>
    <van-popup v-model="showStatus" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsStatus"
        @confirm="onConfirmStatus"
        @cancel="showStatus=false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月"
        :min-date="minDate"
        @cancel="showPicker=false"
        @confirm="confirmPicker"
      />
    </van-popup>
    <ul class="list-weekend-menu">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <li class="item" v-for="(item,index) in weekendList" :key="index">
            <div class="title">{{ item.WeekName }}</div>
            <div class="info-wrap">
              <div class="info-p"><span class="t">计划人：</span>{{ item.UserDep }}-{{ item.UserWork }}-{{ item.UserName }}</div>
              <div class="info-p"><span class="t">事件数：</span>{{ item.Lst.length }}</div>
              <div class="info-p"><span class="t">时&emsp;间：</span>{{ item.WeekDate }}</div>
              <div class="info-p">
                <span class="t">内&emsp;容：</span>
                <div class="info">
                  <p v-for="(item2,index2) in item.Lst" :key="index2">
                    <span class="progress">{{ Number(item2.ProjectPlan).toFixed(0) }}%</span>
                    {{ index2 + 1 }}.{{ item2.ProjectName }}
                  </p>
                </div>
              </div>
              <div class="info-p">
                <span class="t">备&emsp;注：</span>
                <div class="textarea dis">
                  {{ item.WeekContent == -1 ? '员工暂未提交' : item.WeekContent }}
                </div>
              </div>
              <div class="info-p">
                <span class="t">评&emsp;级：</span>
                <div class="abc-wrap">
                  <div class="abc" :class="{'a':item.WeekRate=='A'}"
                       @click="onGrade('A',index,item.UserSysno,item.WeekDateB,item.WeekNameVauel,item.WeekContent,item.WeekRate)">A
                  </div>
                  <div class="abc" :class="{'b':item.WeekRate=='B'}"
                       @click="onGrade('B',index,item.UserSysno,item.WeekDateB,item.WeekNameVauel,item.WeekContent,item.WeekRate)">B
                  </div>
                  <div class="abc" :class="{'c':item.WeekRate=='C'}"
                       @click="onGrade('C',index,item.UserSysno,item.WeekDateB,item.WeekNameVauel,item.WeekContent,item.WeekRate)">C
                  </div>
                </div>
              </div>
            </div>
          </li>
        </van-list>
      </van-pull-refresh>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minDate: new Date(2020, 1, 1),
      currentDate: new Date(),
      showPicker: false,

      showStatus: false,
      columnsStatus: ['全部', '可评', '已评'],
      status: 0,

      keywords: '',
      startDate: '',

      weekendList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pcount: 10,
      allcount: 0
    }
  },
  mounted() {

  },
  watch: {
    keywords() {
      this.onRefresh()
    }
  },
  methods: {
    onLoad() {
      let searchkey = this.$basecode.base64encode(this.$basecode.utf16to8(this.keywords)) || ''
      let data = {
        RequestDate: this.startDate,
        StatusKey: this.status,
        SearchKey: searchkey,
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetAllUserWeekItem', data, res => {
        console.log(res);
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false

        res = res.WebGetAllUserWeekItemResult
        if (res.ResponseCode == 1) {
          // this.allcount = res.AllCount;
          if (res.WeekConclst) {
            this.weekendList.push(...res.WeekConclst)
          }
          if (this.weekendList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }

        } else {
          this.finished = true
        }
      }, err => {
      })
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.weekendList = [];
      this.onLoad()
    },
    confirmPicker(e) {
      let year = e.getFullYear()
      let month = e.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = e.getDate()
      day = day < 10 ? '0' + day : day
      this.startDate = year + '-' + month + '-' + day;
      // this.startDate = year+'-'+month;
      this.showPicker = false
      this.onRefresh()
    },
    onConfirmStatus(e, index) {
      this.status = index
      this.showStatus = false
      this.onRefresh();
    },
    // 评级
    onGrade(grade, index, sysno, date, name, iscan, WeekRate) {
      if (localStorage.getItem('isaudit') == 1) {
        // this.$dialog.confirm({
        //     title:''
        // })
        if (WeekRate != 0) {
          this.$toast('已评级')
          return
        }
        if (iscan == -1) {
          this.$toast('该员工暂未提交，还不能评价')
          return
        }
        this.$dialog.confirm({
          title: '提示',
          message: '是否确认此评级？',
          confirmButtonColor: '#D32F2F'
        }).then(() => {
          let data = {
            UserSysno: sysno,
            WeekRate: grade,
            WeekDate: date, //月份
            WeekName: name //第几周
          }
          this.$baseajax.sliceRequest(this.$base.baseProject + '/WebRateUserWeekItem', data, res => {
            console.log(res);
            if (res.ResponseCode == 1) {
              this.$toast('评级成功')
              this.weekendList[index].WeekRate = grade
            }
          }, err => {
          })
        }).catch(() => {
        })

      }
    },

  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/base.less';

.gc-header-top {
  position: absolute;
  top: .4rem;
  right: .28rem;
  // width: 0.42rem;
  // height: 0.42rem;
  z-index: 99;
  font-size: .37rem;
  color: #fff;
  // background-image:url('~@/assets/admin.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.gc-list-manage-wrap {
  padding-bottom: 1.6rem;
}

.search-wrap {
  margin: 0.28rem .28rem 0;
  padding: .18rem .25rem;
  background-color: #ffffff;
  box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.1);
  border-radius: 0.27rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    font-size: 0.33rem;
    color: #333333;
    padding-right: 0.25rem;
    margin-right: 0.25rem;
    border-right: 1px solid #c8c8c8;
  }

  .right {
    // width: 7rem;
    flex: 1;
    min-width: 0;
  }

  .van-search, .van-search .van-cell {
    padding: 0;
  }

  /deep/ .van-icon-search {
    color: #d1d1d1;
  }

  .van-search__content {
    background: #fff;
    padding-left: 0;
  }

  /deep/ .van-field__control {
    font-size: 0.33rem;
  }

}

.list-weekend-menu {
  padding-left: 0.28rem;
  padding-right: 0.28rem;

  .item {
    margin-top: 0.28rem;
    padding: .48rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
    border-radius: 0.27rem;

    .title {
      font-size: 0.4rem;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;

      span {
        min-width: 0.44rem;
        padding: 0 .1rem;
        height: 0.44rem;
        line-height: 0.44rem;
        border-radius: 100%;
        font-size: 0.32rem;
        color: #ffffff;
        background-color: @color;
        text-align: center;
      }
    }

    .info-p {
      display: flex;
      font-size: 0.3rem;
      color: #888888;
      margin-top: 0.1rem;

      span.t {
        width: 1.4rem;
        flex: 0 0 1.4rem;
        font-size: 0.32rem;
        color: #666666;
      }

      .textarea {
        width: 100%;
        margin-bottom: 0.2rem;
        min-height: 3rem;
        background-color: #f0f0f0;
        border-radius: 0.13rem;
        line-height: 1.6;
        padding: 0.2rem 0.3rem;
        font-size: 0.33rem;
        color: #888;

        &.dis {
          background: none;
          padding: 0;
          min-height: 0;
        }
      }

      p {
        margin-bottom: 0.15rem;
        display: flex;
        align-items: flex-start;

        .progress {
          line-height: 1;
          margin-right: 0.2rem;
          width: 0.92rem;
          flex: 0 0 .92rem;
          padding: .06rem 0;
          font-size: 0.24rem;
          color: #D32F2F;
          border-radius: 0.17rem;
          border: solid 1px #D32F2F;
          text-align: center;
        }
      }
    }

    .abc-wrap {
      display: flex;

      .abc {
        width: 0.64rem;
        margin-right: 0.2rem;
        background-color: #d3d3d3;
        border-radius: 0.07rem;
        font-size: 0.3rem;
        color: #fffefe;
        text-align: center;
      }

      .a {
        background-color: #ff7200;
      }

      .b {
        background-color: #D32F2F;
      }

      .c {
        background-color: #ffeb7a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage/MWeekABC.vue